import React from "react";
import MotivosBaseTemplate from "../shared/MotivosBaseTemplate";
import {
  alterarStatusMotivoTo,
  cadastrarMotivoTo,
  editarMotivoTo,
  excluirMotivoTo,
  listarMotivosTo,
} from "./motivosTo.api";

export default function MotivosToBase() {
  return (
    <MotivosBaseTemplate
      titulo="Motivos TO"
      descricao="Cadastre os motivos usados pelas interdições de TO do CIM."
      placeholder="Ex.: BLOQUEIO"
      hint="Use esta base para centralizar os motivos de TO no CIM."
      listFn={listarMotivosTo}
      createFn={cadastrarMotivoTo}
      updateFn={editarMotivoTo}
      deleteFn={excluirMotivoTo}
      toggleFn={alterarStatusMotivoTo}
    />
  );
}
